import { when, linkify } from '../utils';
import type { Options } from './types';

const generator = ({
  email,
  address,
  phone,
  vat,
  commercialRegister,
  social,
  editor,
  video,
}: Options) => `
# Impressum

## Haftungsausschluss

### Haftung für Inhalte
Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.


### Haftung für Links
Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.


## Lizenzen

Auf dieser Website verwendeten Bilder sind lizenzfrei, eine Quellenangabe ist nicht erforderlich.

## Anbieter der Webseite

- **E-Mail**: [${email}](mailto:${email})
${when(address, `- **Post:** ${address}`)}
${when(phone, `- **Telefon**: ${phone}`)}
${when(vat, `- **USt.-Id**: ${vat}`)}
${when(commercialRegister?.trim(), `
### Angaben zum Unternehmen
${commercialRegister}`)}
${when(social?.length, `

## Dieses Impressum gilt auch für die folgenden Social Media Kanäle

${social?.map((item) => item.trim().length && `- ${linkify(item.trim())}`).filter(Boolean).join('\n')}`)}
${when(editor?.trim(), `

### Redaktionell verantwortlich

${editor}`)}
${when(video?.trim(), `

### Aufsichtsbehörde für Videoinhalte

${video}`)}
`.trim();

export default generator;
